import { css } from "@emotion/react";


export const emotionGlobalCss = css`
.cta {
  background-color: #fafafa
}

.cta .wrap {
  max-width: 650px
}
.wrap {
  margin: 0 auto;
  max-width: 1280px
}

.ctaContent {
  text-align: center;
  padding: 55px 0 140px
}

.ctaContent h2 {
  font-weight: 900
}

.ctaContent p {
  color: #98a2a4;
  line-height: 1.2;
  margin-bottom: 35px;
}
.ctaContent a {
  font-size: 1.4rem;
  text-decoration: none !important;
  color: #fff;
  text-transform: uppercase;
  background: #70c000;
  box-shadow: 0 1px 2px #fff, 0 -1px 1px #fff, inset 0 -1px 1px rgba(0, 0, 0, 0.5), inset 0 1px 1px rgba(255, 255, 255, 0.8);
  padding: 10px 20px;
  font-weight: 600;
  border-radius: 28px
}
.ctaContent a:hover, .ctaContent a:focus {
  opacity: .7;
  color: #fff
}

.innerCityContact .wrap .wrapAbsolute {
  display: flex;
  position: absolute;
  width: 100%;
  top: 50%;
  transform: translateY(-50%)
}
.innerCityContact .wrap {
  position: relative
}
.innerCityContact .wrap .wrapAbsolute>div {
  flex: 1 1 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 25px 35px
}

.cityC {
  background-color: #fff;
  border: 3px solid #70c000;
  border-right-width: 1.5px;
  border-left-width: 1.5px
}

.cityC:first-of-type {
  border-left-width: 3px
}

.cityC:last-of-type {
  border-right-width: 3px
}

.innerCityContact .wrap .wrapAbsolute {
  display: flex;
  position: absolute;
  width: 100%;
  top: 50%;
  transform: translateY(-50%)
}
.innerCityContact .wrap {
  position: relative
}

.innerCityC {
  position: relative
}

.innerCityC i {
  position: absolute;
  left: -30px;
  top: 4px;
  color: #70c000
}

.innerCityC p {
  margin:0;
  margin-bottom: 10px;
  line-height: 1.2;
  color: rgba(0, 0, 0, .8)

}

.innerCityC h3 {
  text-transform: uppercase;
  font-weight: 900;
  font-size: 1.2rem;
  margin: 0;
  margin-bottom: 8px;
}

.innerCityC p:last-of-type {
  margin-bottom: 0
}

.innerCityContact .wrap .wrapAbsolute>div {
  flex: 1 1 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 25px 35px
}
.widgetsBackground {
    background: rgba(0, 0, 0, 0.10);
    position:relative;
  }
.widgetsBackground .gatsby-image-wrapper img{
  height:340px;
}

.wrapAbsolute{
    z-index: 1;
}

.contactIcon{
  top:1px !important;
  width: 25px;
  height: 25px;
}
.hoursIcon{
  top:1px !important;
  width: 25px;
  height: 25px;
}

.footer-widgets {
  background-color: rgba(0, 0, 0, .8);
  clear: both;
  font-size: 18px;
  font-size: 1.1rem;
  padding: 130px 0 40px;
  color: rgba(255, 255, 255, .5)
}
// .footer-widgets .wrap .widget-area.footer-widgets-3.footer-widget-area {
//   flex: 0 0 46%
// }

// .footer-widgets .widget ul>li {
//   margin-bottom: 0
// }

// .footer-widgets a {
//   color: rgba(255, 255, 255, .5);
//   text-decoration: none !important
// }

// .footer-widgets a:hover, .footer-widgets a:focus {
//   color: #fff
// }

.footer-widgets-1 .textwidget img {
  max-width: 300px;
  width: 100%;
  display: block
}
.textwidget{
  margin:0 10px 0;
  text-align:center;
  min-height: 145px;
}
.left{
  margin:0 10px 0;
  text-align:center;
}
// .footer-widgets .wrap {
//   display: flex;
//   align-items: center;
//   justify-content: space-between
// }
// .footer-widgets .wrap>div {
//   flex: 0 0 22%;
//   position: relative
// }

// .footer-widgets .wrap::before, .footer-widgets .wrap::after {
//   content: none
// }

// .footer-widgets .wrap .widget-area.footer-widgets-1.footer-widget-area {
//   flex: 0 0 30%
// }

.widget-area.footer-widgets-4.footer-widget-area::before {
  content: "";
  height: 100%;
  width: 2px;
  background-color: rgba(255, 255, 255, .5);
  position: absolute;
  left: -20px
}
.widget {
  margin-bottom: 40px;
  word-wrap: break-word
}

.widget p:last-child, .widget ul>li:last-of-type, .widget-area .widget:last-of-type {
  margin-bottom: 0
}

.widget ul>li {
  margin-bottom: 10px;
  padding-bottom: 10px
}

.widget ul>li:last-of-type {
  padding-bottom: 0
}

.widget ol>li {
  list-style-position: inside;
  list-style-type: decimal;
  padding-left: 20px;
  text-indent: -20px
}

.widget li li {
  border: 0;
  margin: 0 0 0 30px;
  padding: 0
}
.socialMedia a {
  background-color: #70c000;
  color: #fff;
  width: 35px;
  height: 35px;
  line-height: 35px;
  display: inline-block;
  text-align: center;
  border-radius: 50%;
  font-size: 16px;
  margin-right: 10px;
  margin-bottom: 10px
}

.socialMedia a i {
  line-height: 35px;
  font-size: 16px
}
.site-footer a {
  color: #fff;
  text-decoration: none
}

footer.site-footer .wrap {
  display: flex;
  justify-content: space-between;
  align-items: center
}

footer.site-footer .wrap::before, footer.site-footer .wrap::after {
  content: none
}
.site-footer a:hover, .site-footer a:focus {
  opacity: .7;
  color: #fff
}
.author-box::before, .clearfix::before, .entry::before, .entry-content::before, .footer-widgets::before, .nav-primary::before, .nav-secondary::before, .pagination::before, .site-container::before, .site-footer::before, .site-header::before, .site-inner::before, .widget::before, .wrap::before {
  content: " ";
  display: table
}

.author-box::after, .clearfix::after, .entry::after, .entry-content::after, .footer-widgets::after, .nav-primary::after, .nav-secondary::after, .pagination::after, .site-container::after, .site-footer::after, .site-header::after, .site-inner::after, .widget::after, .wrap::after {
  clear: both;
  content: " ";
  display: table
}
.site-footer .genesis-nav-menu {
  padding-bottom: 20px
}

.site-footer .genesis-nav-menu a {
  padding: 0 20px 10px
}
.site-footer {
  background-color: #70c000;
  font-size: 16px;
  font-size: 1.6rem;
  line-height: 1;
  padding: 30px 0;
  color: #fff;
}

.site-footer p {
  margin: 0;
  font-size: 1rem;
}




/* //////////////////////////////////////////////////////////////////////////// */
@media only screen and (max-width:1023px) {

  body .innerCityContact .wrap .wrapAbsolute {
    flex-wrap: wrap;
    position: relative;
    top: auto;
    transform: none;
    padding: 20px 0
  }

  body .innerCityContact .wrap .wrapAbsolute>div {
    margin: 15px auto
  }

  body .innerCityContact .wrap .wrapAbsolute>div {
    margin: 15px auto
  }
  body .cityC {
    border-width: 3px
  }
  body .innerCityContact .wrap .wrapAbsolute {
    flex-wrap: wrap;
    position: relative;
    top: auto;
    transform: none;
    padding: 20px 0
  }

  body .innerCityContact .wrap .wrapAbsolute>div {
    margin: 15px auto
  }

  body .innerCityContact .wrap .wrapAbsolute>div {
    margin: 15px auto
  }
  body .footer-widgets .wrap {
    flex-wrap: wrap
  }

  body .footer-widgets {
    padding: 30px 0
  }
  .site-footer {
    margin-bottom: 0
  }
  body footer.site-footer .wrap {
    flex-wrap: wrap
  }

  body footer.site-footer .wrap>div {
    flex: 1 1 100%;
    margin: 10px 0 !important
  }
  .widgetsBackground .gatsby-image-wrapper img{
    height:300px;
  }
  .innerCityContact{
    margin: -60px 0 0;
  }

}


`  